import { Component, ElementRef, Inject, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { ClipboardService } from 'ngx-clipboard';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-error-dialog-jar',
    templateUrl: './error-dialog-jar.component.html',
    styleUrls: ['./error-dialog-jar.component.scss'],
    standalone: false
})
export class ErrorDialogJarComponent {
  copy: boolean;
  formattedLines: string[] = [];
  hideReportButton: boolean;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any, private matDialog: MatDialog, public matdialogRef: MatDialogRef<ErrorDialogJarComponent>, private clipboardApi: ClipboardService,
    public sidenavService: SidenavService, private authService: AuthService, private translocoService: TranslocoService) {
  }

  ngOnInit(): void {
  }

  openContactForm(): void {
    this.matdialogRef.close(true);
    this.matDialog.open(ContactUsDialogComponent, {
      panelClass: 'right-dialog-panel',
      width: '29vw',
      position: { right: '0' },
      hasBackdrop: true,
      data: {
        matDialog:  true,
      }
    });

  }

  copyText(): void {
    const jsonString = JSON.stringify(this.data, null, 2);
    this.formattedLines = jsonString.split('\n');
    const copyJson = this.formattedLines.join('\n');
    this.copy = true;
    this.clipboardApi.copyFromContent(copyJson);
    setTimeout(() => {
      this.copy = false;
    }, 5000);
  }

  closeWithSlideOut(): void {
    const dialogContainer = document.querySelector('.right-dialog-panel');
    if (dialogContainer) {
      dialogContainer.classList.add('slide-out');
      setTimeout(() => {
        this.matdialogRef.close();
      }, 200);
    } else {
      this.matdialogRef.close();
    }
  }

  downloadJson(): void {
    const jsonString = JSON.stringify(this.data, null, 2);
    const uint8Array = new TextEncoder().encode(jsonString);
    const base64Data = btoa(String.fromCharCode(...uint8Array));
    const linkSource = 'data:application/json;base64,' + base64Data;
    const title = this.data?.title?.toString()?.trim() + '-' + this.data?.jarName?.toString()?.trim() || 'data';
    const fileName = `${title}.json`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }



}
